<script>
import bread from '@/components/bread'
export default {
  name: 'Cell_Line_Construction',
  components: { bread },
  data() {
    return {}
  }
}
</script>

<template>
  <div class="wrap wrap-tec">
    <div class="banner">
      <img src="@/assets/img/产品及服务/细胞株构建/banner.png" title="细胞株构建" alt="细胞株构建" class="img-fluid">
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container">
      <div class="texture-body">
        <p>
          细胞株构建是一项关键的生物技术，用于创建稳定表达或敲除特定基因的细胞系。它广泛应用于基因功能研究、疾病机制研究、药物筛选及生物制品生产等领域。
        </p>
        <p>
          当外源基因转入细胞后，有两种表达方式：瞬时表达和稳定表达。瞬时表达中，外源DNA不会整合到宿主细胞染色体DNA中，只能在细胞内暂时高效表达，持续时间较短。而稳定表达中，外源DNA整合到细胞染色体DNA上，随细胞分裂稳定传递给子代细胞，形成稳定的转化细胞株。
        </p>
        <P>
          多克隆稳定细胞株（cell pool）是转染后直接用抗药筛选得到的，由多个不同来源的细胞克隆组成，外源基因整合位点和表达水平存在差异。周期短，费用低，适用于初步筛选和高表达量应用。
        </P>
        <p>
          单克隆稳定细胞株是cell pool经有限稀释法等方法筛选得到，含有稳定整合外源片段的单个细胞克隆组成，所有细胞具有相同的外源基因整合位点，确保表达的一致性和稳定性，适用于高精度研究和生物制品生产。周期长，费用高，适用于需进行细胞亚定位实验的细胞系，难感染和低表达量应用。
        </p>
        <p>
          擎科生物提供从基因序列到稳定细胞株交付的一站式服务，为客户高效提供提供稳定表达或敲除特定基因150+种细胞株服务，包括大部分模式细胞、肿瘤细胞，同时可进行单克隆细胞株WB实验或蛋白质组学验证。
        </p>
      </div>

    </section>
    <section class="container padding-reset-top">
      <div class="c-title">服务流程<small>Service Process</small></div>
      <div class="service-process-image">
        <img src="@/assets/img/产品及服务/细胞株构建/service-process.png" />
      </div>
    </section>
    <div class="service-advantage-bg">
      <div class="container padding-reset-top">
        <div class="c-title">服务优势<small>Service advantage</small></div>
        <div class="service-advantage-content flex">
          <div class="left">
            <img src="@/assets/img/产品及服务/细胞株构建/service-advantage-img.png" class="img-fluid">
          </div>
          <div class="right">
            <div class="required">
              <p class="mb20">1.150+种细胞轻松搞定，包括大部分模式细胞、肿瘤细胞</p>
              <p class="mb20">2.自动化实验流程，快至6周交付</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="c-title">服务内容<small> Service Details</small></div>
      <div class="container con">
        <table class="service-details-table" cellpadding="0" cellspacing="0">
          <tr>
            <th width="140px">产品大类</th>
            <th width="190px">产品名称</th>
            <th width="318px">规格</th>
            <th width="152px">周期（自然日）</th>
            <th width="401px">备注</th>
          </tr>
          <tr>
            <td rowspan="6">细胞株构建</td>
            <td>敲除细胞株构建（单克隆）</td>
            <td>冻存或培养瓶装阳性克隆细胞细胞株，1管，≥1E+6 cell/株</td>
            <td>8周起</td>
            <td>
              <div>1.确保目标基因的两个等位基因均发生移码突变</div>
              <div>2.尽量让切割位置更靠近基因序列的5'端,以保证KO效果</div>
              <div>3.无需对照，可蛋白水平验证</div>
            </td>
          </tr>
          <tr>
            <td>敲除细胞株构建（cell pool）</td>
            <td>冻存或培养瓶装阳性克隆细胞细胞株，1管，≥1E+6 cell/株</td>
            <td>6周起</td>
            <td>
              <div>1.尽量让切割位置更靠近基因序列的5'端,以保证KO效果</div>
              <div>2.KO cell pool可能并不会在蛋白水平有明显的KO效果，建议筛选单克隆KO细胞进行下游实验</div>
              <div>3.无需对照，可蛋白水平验证</div>
            </td>
          </tr>
          <tr>
            <td>过表达/干扰细胞株构建（单克隆）</td>
            <td>冻存或培养瓶装阳性克隆细胞细胞株，1管，≥1E+6 cell/株；对照细胞株，2管，1E+6 cell/株</td>
            <td>8周起</td>
            <td>含对照，可蛋白水平验证</td>
          </tr>
          <tr>
            <td>过表达/干扰细胞株构建（cell pool）</td>
            <td>冻存或培养瓶装阳性克隆细胞细胞株，1管，≥1E+6 cell/株；对照细胞株，2管，1E+6 cell/株</td>
            <td>6周起</td>
            <td>含对照，可蛋白水平验证</td>
          </tr>
          <tr>
            <td>点突变细胞株构建（纯合子单克隆）</td>
            <td>冻存或培养瓶装阳性克隆细胞细胞株，1管，≥1E+6 cell/株；对照细胞株，2管，1E+6 cell/株</td>
            <td>11周起</td>
            <td>Sanger测序验证，保证两个等位基因均发生突变</td>
          </tr>
          <tr>
            <td>敲入细胞株构建（单克隆）</td>
            <td>冻存或培养瓶装阳性克隆细胞细胞株，1管，≥1E+6 cell/株；对照细胞株，2管，1E+6 cell/株</td>
            <td>11周起</td>
            <td>Sanger测序验证，保证两个等位基因均发生敲入qPCR验证保证敲入片段发生表达</td>
          </tr>
          <tr>
            <td colspan="5">
              注:可进行单克隆细胞株WB实验或蛋白质组学验证。
            </td>
          </tr>

        </table>
      </div>
      <div class="cons" style="margin-top: 20px;">

      </div>
    </div>
    <div class="container padding-reset-top">
      <div class="c-title">案例展示<small> Case</small></div>
      <div class="container con">
        <div class="texture-body">
          <p class="noIndent"><span class="highLightTexture">敲除细胞株构建：</span>WB实验或蛋白质组学验证，确保蛋白水平敲除。</p>
        </div>
        <div class="case-image">
          <img src="@/assets/img/产品及服务/细胞株构建/case-img.png" />
        </div>

      </div>
      <div class="cons" style="margin-top: 20px;">

      </div>
    </div>
    <div class="container">
      <qk-consult type="cellLineConstruction"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .compose-type1 .neirong{
    display: block!important;
  }
  .effect-lists1{
    flex-wrap: wrap;
    justify-content: flex-start!important;
  }
  .required{
    margin-top: 5px!important;
  }
  .compose-type1{
    padding-bottom: 20px!important;
  }
}
@media screen and (min-width: 641px){
  .effect-lists{
    //display: block!important;
    justify-content: space-between!important;
    flex-wrap:wrap;
    overflow: auto;
  }
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title{
  padding-top: 81px;
}
.c-title small{
  margin-top: 10px;
}
.required{
  margin-top: 50px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}

.effect-lists li{
  width: 21% !important;
}
.cons{
  display: none;
}
.texture-body{
  p{
    text-indent: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 29px;
    text-align: justify;
    font-style: normal;
    text-transform: none;
    margin-bottom: 20px;
    &:last-child{
      margin-bottom: 0;
    }
    &.noIndent{
      text-indent: 0;
    }
  }
}

.highLightTexture{
  color: #13489D;
}
.service-process-image{
  img{
    width: 1200px;
  }
}
.case-image{
  margin-top: 50px;
  img {
    width: 1200px;
  }
}
.padding-reset-top{
  padding-top: 0px !important;
}
.service-advantage-bg{
  background: #F6FAFD;
  margin-top: 100px;
}
.service-advantage-content{
  .left {
    padding-bottom: 80px;
    .img-fluid {
      width: 415px; height: 292px;
    }
  }
}
.service-details-table{
  width: 100%;
  border-left: 1px solid #E4E6EA;
  border-top: 1px solid #E4E6EA;
  tr{
    th{
      padding: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      font-style: normal;
      background: #F6FAFD;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
    }
    td{
      padding: 20px;
      padding-left: 30px;
      padding-right: 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      font-style: normal;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
    }
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>



// WEBPACK FOOTER //
// src/views/products/Cell_Line_Construction.vue